import { apiClient, Auth } from '@/shared/api'

import { THostContractStatusCount } from '../model/schema'

export const getHostContractStatusCount = async () => {
  const response = await apiClient.get<THostContractStatusCount>({
    endpoint: `/host/contracts/masters/status/count`,
    auth: Auth.REQUIRED,
  })

  return response
}
